/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ui_Thresholds_Max_WattsInputs */

const en_ui_thresholds_max_watts = /** @type {(inputs: Ui_Thresholds_Max_WattsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max ${i?.value}W`)
};

const de_ui_thresholds_max_watts = /** @type {(inputs: Ui_Thresholds_Max_WattsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max. ${i?.value}W`)
};

/**
* | output |
* | --- |
* | "Max {value}W" |
*
* @param {Ui_Thresholds_Max_WattsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_max_watts = /** @type {((inputs: Ui_Thresholds_Max_WattsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Max_WattsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_max_watts(inputs)
	return de_ui_thresholds_max_watts(inputs)
});